import { Component, inject } from "@angular/core";
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef
} from "@angular/material/snack-bar";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";

export interface ToastData {
  message: string;
  action: string;
  type: "success" | "error" | "info";
  icon: string;
}

/**
 * Minimal toast surface for ToastService: a white card with a thin colored
 * left bar + a colored state icon (green / red / grey) and dark text. Opened
 * via MatSnackBar.openFromComponent. The MDC snackbar surface is neutralised
 * (transparent, no padding) in styles.css (.trd-toast-panel) so only this card
 * shows.
 */
@Component({
  selector: "app-toast",
  standalone: true,
  imports: [MatIcon, MatButton],
  template: `
    <div class="ti ti-{{ data.type }}">
      <mat-icon class="ti-ic">{{ data.icon }}</mat-icon>
      <span class="ti-msg">{{ data.message }}</span>
      <button mat-button class="ti-act" (click)="ref.dismiss()">{{ data.action }}</button>
    </div>
  `,
  styles: [
    `
    :host { display:block; }
    .ti { display:flex; align-items:center; gap:11px; min-width:300px; max-width:92vw;
      padding:12px 6px 12px 14px; background:#fff; border:1px solid #dcdcdc;
      border-left-width:4px; border-radius:8px; color:#1a1a1a;
      font:500 14px "Open Sans", Roboto, sans-serif;
      box-shadow:0 4px 14px rgba(0,0,0,.10); }
    .ti-ic { flex:0 0 auto; font-size:20px; width:20px; height:20px; }
    .ti-msg { flex:1 1 auto; line-height:1.35; }
    .ti-act { flex:0 0 auto; min-width:auto; font-weight:600; font-size:12px;
      letter-spacing:.05em; text-transform:uppercase; color:#6b6b6b; }
    .ti-success { border-left-color:#2e7d32; } .ti-success .ti-ic { color:#2e7d32; }
    .ti-error   { border-left-color:#c62828; } .ti-error .ti-ic { color:#c62828; }
    .ti-info    { border-left-color:#9a9a9a; } .ti-info .ti-ic { color:#6b6b6b; }
    `
  ]
})
export class ToastComponent {
  data = inject<ToastData>(MAT_SNACK_BAR_DATA);
  ref = inject(MatSnackBarRef);
}
